import {useState, useEffect} from 'react';
import {defaults} from 'lib.common';
const {funcionVacia} = defaults;

export default function useApiRest(
   endpoint,
   {
      callbackProcesarData = funcionVacia,
      callbackError = funcionVacia,
      callbackLoading = funcionVacia
   } = {},
   fetchOptions = {}
) {
   const [loading, setLoading] = useState(false);
   useEffect(() => {
      callbackLoading(loading);
   }, [loading]);

   const [error, setError] = useState(undefined);
   useEffect(() => {
      if (error) {
         callbackError(error);
      }
   }, [error]);

   const [data, setData] = useState(undefined);
   useEffect(() => {
      if (data) {
         callbackProcesarData(data);
      }
   }, [data]);

   function fetchApi({resource, endpoint: newEndpoint, ...otherOptions}) {
      const options = {
         ...fetchOptions,
         ...otherOptions
      };
      let finalEndpoint = newEndpoint || endpoint;
      finalEndpoint = resource ? `${finalEndpoint}${resource}` : finalEndpoint;
      fetch(finalEndpoint, options)
         .then((response) => {
            if (response.ok) {
               return response.json();
            }
            return response.text().then((text) => {
               throw new Error(text);
            });
         })
         .then((dataResponse) => {
            setData(dataResponse);
            setLoading(false);
            setError(undefined);
         })
         .catch((error) => {
            setError(error);
            setData(undefined);
            setLoading(false);
         });
      setLoading(true);
   }

   return [fetchApi, {data, loading, error}];
}
